import { useTheme, useMediaQuery } from "@mui/material";

export function useGroupFields() {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));

  const getGroupedFields = (fields) => {

    const rows = [];
    let currentRow = [];
    let total = 0;

    fields?.forEach(field => {
      const col = isXs ? 12 : isSm || isMd ? (field.columns < 12 ? 6 : 12) : field.columns;

      // If adding this item exceeds 12, start new row
      if (total + col > 12) {
        rows.push(currentRow);
        currentRow = [field];
        total = col;
      } else {
        currentRow.push(field);
        total += col;
      }
    });

    if (currentRow.length) rows.push(currentRow);
    return rows;
  };

  return {getGroupedFields};
}